var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTireSelected = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4098 71.0222C54.9661 71.0222 70.8196 55.1667 70.8196 35.6078C70.8196 16.0489 54.9661 0.193359 35.4098 0.193359C15.8535 0.193359 0 16.0489 0 35.6078C0 55.1667 15.8535 71.0222 35.4098 71.0222Z",
    fill: "#FA6400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0988 24.7422L26.4876 31.3179C28.1469 32.7896 27.3016 35.5451 25.0787 35.7956L15.467 36.9228",
    stroke: "white",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4494 17.3223L36.4733 26.3715C35.5966 28.4068 32.6849 28.4381 31.777 26.4028L27.7382 17.6041",
    stroke: "white",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1325 35.362L44.3016 34.3913C42.0787 34.1721 41.1708 31.4479 42.7988 29.9136L49.9372 23.3379",
    stroke: "white",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2012 53.9267L39.0723 44.2823C38.6026 42.0904 40.9194 40.3995 42.8606 41.4955L51.3139 46.255",
    stroke: "white",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5653 47.3834L28.0812 42.3735C29.9911 41.2462 32.3392 42.9371 31.9009 45.0977L29.9911 54.5854",
    stroke: "white",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4085 55.3681C46.3192 55.3681 55.1641 46.5221 55.1641 35.6099C55.1641 24.6976 46.3192 15.8516 35.4085 15.8516C24.4978 15.8516 15.653 24.6976 15.653 35.6099C15.653 46.5221 24.4978 55.3681 35.4085 55.3681Z",
    stroke: "white",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4104 39.1176C37.347 39.1176 38.917 37.5474 38.917 35.6105C38.917 33.6737 37.347 32.1035 35.4104 32.1035C33.4738 32.1035 31.9039 33.6737 31.9039 35.6105C31.9039 37.5474 33.4738 39.1176 35.4104 39.1176Z",
    stroke: "white",
    strokeWidth: 0.688774,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4097 64.3532C51.283 64.3532 64.1508 51.4837 64.1508 35.6083C64.1508 19.7329 51.283 6.86328 35.4097 6.86328C19.5364 6.86328 6.66858 19.7329 6.66858 35.6083C6.66858 51.4837 19.5364 64.3532 35.4097 64.3532Z",
    stroke: "white",
    strokeWidth: 1.58638,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTireSelected, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tire_selected.f4d5fc10.svg";
export { ForwardRef as ReactComponent };